export default "__VITE_ASSET__DJxZtrzi__"